__turbopack_context__.v({
  "actionButton": "tenantInvestorSet-module-scss-module__ionq-W__actionButton",
  "description": "tenantInvestorSet-module-scss-module__ionq-W__description",
  "intro": "tenantInvestorSet-module-scss-module__ionq-W__intro",
  "lgContainer": "tenantInvestorSet-module-scss-module__ionq-W__lgContainer",
  "mdContainer": "tenantInvestorSet-module-scss-module__ionq-W__mdContainer",
  "narrowContainer": "tenantInvestorSet-module-scss-module__ionq-W__narrowContainer",
  "pageContainer": "tenantInvestorSet-module-scss-module__ionq-W__pageContainer",
  "secondaryBtn": "tenantInvestorSet-module-scss-module__ionq-W__secondaryBtn",
  "sectionDescription": "tenantInvestorSet-module-scss-module__ionq-W__sectionDescription",
  "sectionTitle": "tenantInvestorSet-module-scss-module__ionq-W__sectionTitle",
  "title": "tenantInvestorSet-module-scss-module__ionq-W__title",
  "titlePattern": "tenantInvestorSet-module-scss-module__ionq-W__titlePattern",
});
